console.log('my-scripts.js loaded');
$(document).ready(function () {
    if ($('.product-recommendations').length) {
        getProductRecommendations();
    }

    if ($('.shopify-cart-qty').length) {
        updateShopifyDetails();
    }

    if ($('#customer_login').length) {
        customerEventListeners();
    }

    // Banner Auto-Rotation
    if ($('.banner-info').length > 1) {
        initBannerCarousel();
    }

    // $('.add-to-cart').on('click', function () {
    //     const self = this;

    //     var itemData = {
    //         items: [
    //             {
    //                 quantity: 1,
    //                 id: $(this).attr('data-variant'),
    //                 properties: {
    //                     'First name': 'Caroline'
    //                 }
    //             }
    //         ]
    //     };

    //     $.ajax({
    //         url: '/cart/add.js',
    //         data: itemData,
    //         type: 'POST',
    //         beforeSend: function () {
    //             $(self).html('Please wait...');
    //         },
    //         complete: function () {
    //             updateShopifyDetails();
    //             $(self).html('Added to cart');
    //         }
    //     })
    // })

    // commentent code 
    // $('.add-to-cart').off('click').on('click', function (e) {
    //     e.preventDefault();
    //     const self = this;
    //     const variantId = $(this).data('variant');

    //     var itemData = {
    //         items: [
    //             {
    //                 id: variantId,
    //                 quantity: 1,
    //                 properties: {
    //                     'First name': 'Caroline'
    //                 }
    //             }
    //         ]
    //     };

    //     $.ajax({
    //         url: '/cart/add.js',
    //         type: 'POST',
    //         data: JSON.stringify(itemData),       // Must stringify the object
    //         dataType: 'json',
    //         contentType: 'application/json',      // Tell Shopify it's JSON
    //         beforeSend: function () {
    //             $(self).html('Please wait...');
    //         },
    //         success: function (item) {
    //             // Update cart counter or any other UI updates
    //             $.getJSON('/cart.js', function (cart) {
    //                 $('#cart-count').text(cart.item_count);
    //             });
    //         },
    //         complete: function () {
    //             $(self).html('Added to cart');
    //         },
    //         error: function (err) {
    //             console.error(err);
    //             alert('Failed to add item to cart');
    //         }
    //     });
    // });


    $('.product-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.product-images-nav'
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var newHeight = $('[data-slick-index="' + nextSlide + '"]').height();

        $('.product-images').css("height", newHeight);
    });

    $('.product-images-nav').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.product-images',
        dots: false,
        centerMode: false,
        focusOnSelect: true
    });




});

// Functions
const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function getProductRecommendations() {
    var $container = $('.product-recommendations');

    var baseUrl = $container.data('baseUrl');
    var productId = $container.data('productId');
    var limit = $container.data('limit');

    var getProductUrl = baseUrl + '?section_id=product-recommendations&limit=' + limit +
        '&product_id=' + productId;

    $.ajax({
        url: getProductUrl,
        type: 'get',
        success: function (res) {
            $container.html(res);
        }
    })
}


function updateShopifyDetails() {
    $.ajax({
        url: '/cart.js',
        type: 'GET',
        dataType: 'json',
        success: function (res) {
            $('.shopify-cart-qty').html(res.item_count);

            if ($('.shopify-cart-total').length) {
                $('.shopify-cart-total').html(res.currency + numberWithCommas(res.total_price));
            }
        }
    })
}

function customerEventListeners() {
    $('#RecoverPassword, #HideRecoverPasswordLink').on('click', function () {
        $('#RecoverPasswordForm, #CustomerLoginForm').slideToggle(300);
    });
    var locationHash = window.location.hash.substring(1);

    console.log(locationHash);

    if (locationHash == 'recover') {
        $('#RecoverPasswordForm, #CustomerLoginForm').slideToggle(300);
    }
}

/**
 *
 *  Show/hide customer address forms
 *
 */
function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');
    var $newAddressFormButton = $('#AddressNewButton');

    if (!$newAddressForm.length) {
        return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(
            'AddressCountryNew',
            'AddressProvinceNew',
            {
                hideElement: 'AddressProvinceContainerNew'
            }
        );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function () {
        var formId = $(this).data('form-id');
        var countrySelector = 'AddressCountry_' + formId;
        var provinceSelector = 'AddressProvince_' + formId;
        var containerSelector = 'AddressProvinceContainer_' + formId;

        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
            hideElement: containerSelector
        });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function () {
        var isExpanded = $newAddressFormButton.attr('aria-expanded') === 'true';

        $newAddressForm.toggleClass('hide');
        $newAddressFormButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-edit-toggle').on('click', function () {
        var formId = $(this).data('form-id');
        var $editButton = $('#EditFormButton_' + formId);
        var $editAddress = $('#EditAddress_' + formId);
        var isExpanded = $editButton.attr('aria-expanded') === 'true';

        $editAddress.toggleClass('hide');
        $editButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-delete').on('click', function () {
        var $el = $(this);
        var target = $el.data('target');
        var confirmMessage = $el.data('confirm-message');

        // eslint-disable-next-line no-alert
        if (
            confirm(
                confirmMessage || 'Are you sure you wish to delete this address?'
            )
        ) {
            Shopify.postLink(target, {
                parameters: { _method: 'delete' }
            });
        }
    });
}

// ================== CART COUNTER SCRIPT ==================
// Function to update the cart counter
function updateCartCount() {
    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            document.getElementById('cart-count').innerText = cart.item_count;
        });
}

// Initialize counter on page load
updateCartCount();

// Handle Add to Cart clicks
// document.querySelectorAll('.add-to-cart').forEach(button => {
//     button.addEventListener('click', function (e) {
//         e.preventDefault();

//         const variantId = this.dataset.variant;
//         const quantity = 1; // Adjust if you have a quantity input

//         fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: variantId, quantity: quantity })
//         })
//             .then(res => res.json())
//             .then(() => {
//                 updateCartCount(); // Refresh counter instantly
//             })
//             .catch(err => console.error(err));
//     });
// });


// Banner Carousel Function
function initBannerCarousel() {
    const banners = document.querySelectorAll('.banner-info');
    if (banners.length === 0) return;

    let currentIndex = 0;
    const interval = 8000; // 8 seconds per slide

    // Set first banner as active
    banners[0].classList.add('active');

    function rotateBanner() {
        // Remove active class from current banner and add previous class
        banners[currentIndex].classList.remove('active');
        banners[currentIndex].classList.add('previous');

        // Move to next banner
        currentIndex = (currentIndex + 1) % banners.length;

        // Add active class to new banner
        banners[currentIndex].classList.add('active');

        // Remove previous class after transition (1 second)
        setTimeout(() => {
            banners.forEach(banner => banner.classList.remove('previous'));
        }, 1000);
    }

    // Auto-rotate every 5 seconds
    setInterval(rotateBanner, interval);
}

document.addEventListener("DOMContentLoaded", function () {
    const toggle = document.getElementById("search-toggle");
    const form = document.getElementById("searchform");

    if (!toggle || !form) return; // ✅ IMPORTANT

    toggle.addEventListener("click", function () {
        form.style.display = form.style.display === "block" ? "none" : "flex";
    });

    document.addEventListener("click", function (e) {
        if (!form.contains(e.target) && e.target !== toggle) {
            form.style.display = "none";
        }
    });
});


// $(document).ready(function() {
//   $('.add-to-cart').on('click', function(e) {
//     e.preventDefault(); // prevent default button action

//     const variantId = $(this).data('variant');

//     // Add to cart via AJAX
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: { quantity: 1, id: variantId },
//       dataType: 'json',
//       success: function(item) {
//         // Get the updated cart count
//         $.getJSON('/cart.js', function(cart) {
//           $('#cart-count').text(cart.item_count); // update cart counter
//         });

//         // Optional: show confirmation
//         alert(item.title + ' has been added to your cart!');
//       },
//       error: function(err) {
//         alert('Failed to add item to cart.');
//         console.error(err);
//       }
//     });
//   });
// });
// document.addEventListener('DOMContentLoaded', function () {
//   const form = document.querySelector('#ContactForm'); // your form ID

//   form.addEventListener('submit', function (e) {
//     e.preventDefault(); // stop normal submission

//     const formData = new FormData(form);
//     const emailData = {
//       email: formData.get('contact[email]'),
//       Full_Name: formData.get('contact[name]'),
//       Message: formData.get('contact[body]'),
//     };

//     // send to your email endpoint
//     fetch('https://proweaveremail.com/shopifysendingemail/', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(emailData),
//     })
//       .then((res) => res.json())
//       .then((data) => {
//         // show a success message
//         alert('Email sent successfully!');
//         form.reset();
//       })
//       .catch((err) => {
//         alert('Error sending email, please try again.');
//         console.error(err);
//       });
//   });
// });



// In your <script> tag (Liquid-rendered)
document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || form.id !== 'ContactForm') return;
    e.preventDefault();

    const consent = form.querySelector('#consent_checkbox');
    if (!consent || !consent.checked) {
        alert('Please agree to the Privacy Notice before submitting the form.');
        consent && consent.focus();
        return; // 🚫 STOP — do not proceed
    }

    const formdata = new FormData(form);
    if (formdata.get('Robot')) return;

    const inquiry = formdata.get('contact[Inquiry Type]');
    const message = formdata.get('contact[body]') || '';
    // const fullContent = message + (inquiry ? '\nInquiry Type: ' + inquiry : '');

    // Primary field the server may read
    // formdata.set('contact[body]', fullContent);

    // Fallback fields: some endpoints expect plain keys
    //Note: Gi set ra ang formdata instead nga gi append
    // formdata.set('content', fullContent);
    // formdata.set('message', fullContent);
    // formdata.set('body', fullContent);
    formdata.set('Message', message);
    formdata.set('Inquiry_Type', inquiry);

    // Ensure name & email are available as plain fields too
    try {
        const nameInput = form.querySelector('input[type="text"][name^="contact"]') || form.querySelector('input[type="text"]');
        const emailInput = form.querySelector('input[type="email"][name^="contact"]') || form.querySelector('input[type="email"]');

        const nameVal = (nameInput && nameInput.value) ? nameInput.value : '';
        const emailVal = (emailInput && emailInput.value) ? emailInput.value : '';

        if (nameVal) {
            formdata.set('Full_Name', nameVal);
            formdata.set('name', nameVal);
        }
        if (emailVal) {
            formdata.set('Email_Address', emailVal);
            formdata.set('contact[email]', emailVal);
        }
    } catch (err) {
        // ignore DOM lookup errors
    }

    // Keep your curl-required fields (ensure they exist)
    formdata.set('form_name', 'BRAVE & REGAL | Send Us A Message');
    formdata.set('company_name', 'BRAVE & REGAL');
    formdata.append('email', 'bravenregal@gmail.com');

    fetch('https://proweaveremail.com/shopifysendingemail/', {
        method: 'POST',
        body: formdata
    })
        .then((res) => {
            // try parse json response; otherwise treat as success
            return res.json().catch(() => ({ message: 'Message sent' }));
        })
        // Note: Code ni para naay modal mo display if na send ang form
        // .then((json) => {
        //     const msg = (json && json.message) ? json.message : 'Message sent successfully.';
        //     const prompt = document.getElementById('prompt_message') || document.querySelector('#prompt_message');
        //     if (prompt) prompt.innerHTML = '<p class="success">' + msg + '</p>';
        //     form.reset();
        // })
        .catch((err) => {
            console.error(err);
            const invalid = document.getElementById('invalid-msg') || document.querySelector('#invalid-msg');
            if (invalid) invalid.innerHTML = '<p class="error">Failed to send email.</p>';
        });
});

//JANUARY 16, 2026 MODIFICATION

$(document).ready(function () {
    if ($('#carousel_slider1').length) {

        // Destroy existing Owl (if initialized by theme)
        $('#carousel_slider1').trigger('destroy.owl.carousel');

        // Re-initialize with correct settings
        $('#carousel_slider1').owlCarousel({
            loop: true,
            margin: 15,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                576: {
                    items: 2
                },
                768: {
                    items: 3
                },
                1024: {
                    items: 4
                }
            }
        });
    }
});


